export function getSliderImages() {
    return [
        {
            url: "assets/hero/Claudia-20.jpg",
        },
        {
            url: "assets/hero/Claudia-11.jpg",
        },
        {
            url: "assets/hero/Claudia-29.jpg",
        },
    ];
}

export const elternTiere = [
    {
        id: 1,
        name: "Kira",
        role: "Mutter",
        breed: "Havaneser",
        color: "Weiss-Zobel",
        age: "Zuchttauglich",
        description:
            "Kira ist unsere liebevolle und geduldige Mutterhündin. Sie hat am 02.12.2025 ihren ersten Wurf mit 6 gesunden Welpen zur Welt gebracht und zeigt ein vorbildliches Mutterverhalten.",
        character: "Ruhig, ausgeglichen, sehr sozial",
        awards: ["Zuchttauglichkeitsprüfung bestanden"],
        health: "Gesundheitlich geprüft",
        image:
            "assets/dogs/Claudia-4.jpg",
    },
    {
        id: 2,
        name: "Forrest Belleza Habanero (SAROTTI)",
        role: "Vater",
        breed: "Havaneser",
        color: "Chocolate",
        age: "Zuchttauglich",
        description:
            "Sarotti ist ein kräftiger und charakterstarker Deckrüde mit einer Größe von 26 cm. Er hat einen hervorragenden Stammbaum und überzeugt durch sein ausgeglichenes Wesen.",
        character: "Selbstsicher, freundlich, geduldig",
        awards: ["Deutscher Jugend-Champion VK", "Deutscher Champion VK", "Deutscher Champion VDH"],
        health: "PL 0/0, PRA: frei",
        image:
            "assets/dogs/Sarotti.jpeg",
    },
];

export const jungeHunde = [
    {
        id: "sherry",
        name: "Sherry",
        callName: "Sherry",
        breed: "Havaneser",
        sex: "Hündin",
        origin: "FCI (Ungarn)",

        dob: "2025-08-19",
        color: "red",
        coat: "Langhaar",

        parents: {
            sire: {
                name: "Jo The Funny One Barwuschel",
                color: "red",
                notes:
                    "PL-frei; 4xBOS, 4xCAC, R.CACIB, BOB, 4xHPJ, J.CACIB, Best Junior, HJCH, CACIB",
            },
            dam: {
                name: "Dorothy Crimean Khan",
                color: "red-white",
                notes: "PL-frei",
            },
        },

        breeder: "Marianna Incze, 8800 Nagykanizsa, Felsöerdö u 120 (Ungarn)",

        // Werte sind im PDF noch leer -> sauber als "folgt" führen:
        status: "Junghündin (noch nicht zuchttauglich)",
        description:
            "Sherry ist unsere junge, rote Havaneser-Hündin. Sie wächst bei uns im Familienverbund auf und wird behutsam aufgebaut. Alle weiteren Gesundheits- und Zuchtdaten werden nachgereicht.",

        image:
            "assets/dogs/ClaudiaDez2025-5.jpg", // oder: "/assets/dogs/sherry.jpg"
    },

    {
        id: "amelie",
        name: "Amelie",
        breed: "Havaneser",
        sex: "Hündin",
        color: "chocolate",
        status: "Junghündin (aus unserem aktuellen Wurf)",
        description:
            "Amelie ist aus unserem aktuellen Wurf und wird bei uns bleiben. Weitere Daten (Maße, Untersuchungen, ggf. Ausstellung) folgen, sobald sie alt genug ist.",
        image:
            "assets/dogs/Welpen-1.jpg",
    },
];


export const welpenWurf = {
    name: "A-Wurf",
    date: "02.12.2025",
    count: "6 Welpen (2 Rüden, 4 Hündinnen)",
    parents: "Kira & Sarotti",
    description:
        "Unser erster Wurf aus der Verpaarung von Kira und Sarotti. Alle Welpen sind gesund, munter und entwickeln sich prächtig. Sie wachsen in unserem Zuhause auf und werden liebevoll sozialisiert. Alle Welpen des A-Wurfes haben ihr neues Zuhause gefunden.",
    groupImage:
        "assets/dogs/ClaudiaDez2025-20.jpg",
    puppies: [
        {
            id: 1,
            name: "Amelie",
            gender: "Hündin",
            color: "chocolate",
            character: "Verspielt und neugierig",
            status: "Bleibt bei uns",
            image:
                "assets/dogs/Welpen-1.jpg",
        },
        {
            id: 2,
            name: "Amadeus",
            gender: "Rüde",
            color: "tabakbraun",
            character: "Selbstbewusst und ausgeglichen",
            status: "Vergeben",
            image:
                "assets/dogs/Welpen-3.jpg",
        },
        {
            id: 3,
            name: "Anton",
            gender: "Rüde",
            color: "schwarz-weiss",
            status: "Vergeben",
            character: "Aktiv und lernfreudig",
            image:
                "assets/dogs/Welpen-5.jpg",
        },
        {
            id: 4,
            name: "Anouk (vergeben)",
            gender: "Hündin",
            color: "havannabraun",
            status: "Vergeben",
            character: "Ruhig und anhänglich",
            image:
                "assets/dogs/Welpen-7.jpg",
        },
        {
            id: 5,
            name: "Amira",
            gender: "Hündin",
            color: "schwarz-weiss",
            status: "Vergeben",
            character: "Verschmust und sanft",
            image:
                "assets/dogs/Welpen-9.jpg",
        },
        {
            id: 6,
            name: "Aurelia",
            gender: "Hündin",
            color: "schwarz-weiss",
            status: "Vergeben",
            character: "Neugierig und verspielt",
            image:
                "assets/dogs/Welpen-11.jpg",
        },
    ],
};
export const seminare = [
    "Zuchtstrategien und genetische Vielfalt - Seminar 2025",
    "Welpenaufzucht und Sozialisation - Workshop 2024",
    "Gesundheit und Genetik beim Havaneser - Fachtagung 2023",
    "Ernährung und Pflege von Zuchthunden - Seminar 2023",
];


export const kira = {
    id: "kira",
    name: "Amara of Beautiful little Diamond",
    callName: "Kira",
    breed: "Havaneser",
    sex: "Hündin",
    registry: "DHS 2388058 LH",
    dob: "2023-08-14",

    color: "weiß-zobel",
    coat: "Langhaar",
    heightCm: 24.5,
    weightKg: 5.1,
    bite: "VZ 6/6, Schere",

    health: {
        patella: "0/0 (frei)",
        eyes: "PRA + Katarakt (frei)",
    },

    breeding: {
        approvedSince: "2025-05-15",
    },

    parents: {
        sire: {
            name: "Athos von den nordischen Elfen",
            color: "schwarz-weiß",
            heightCm: 27.5,
            patella: "PL-frei",
        },
        dam: {
            name: "Breathtaking Beauty Tequila",
            color: "red chocolate-weiß",
            heightCm: 26,
            patella: "PL-frei",
        },
    },

    breeder: "Sabrina Dormann, Wilhelmshaven",
    owner: "Claudia Don, Wangerland",

    titles: ["Junghund Champion"],

    showResults: [
        { date: "2024-05-26", place: "Dornbach", result: "SG2 Mons Tabor Winner – 2. Platz" },
        { date: "2024-05-26", place: "Dornbach", result: "SG2 Westerwald Siegerschau – 2. Platz" },

        { date: "2025-05-25", place: "Dornbach", result: "V1 Junghundsieger – 1. Platz Rheinland-Pfalz Siegerschau" },
        { date: "2025-05-25", place: "Dornbach", result: "V1 – 1. Platz Montabaur Siegerschau" },

        { date: "2025-06-15", place: "Quakenbrück", result: "V1 Europasieger 2025 – 1. Platz" },
        { date: "2025-06-15", place: "Quakenbrück", result: "V1 Internationaler Jubiläumssieger 2025 – 1. Platz" },
    ],

    championship: {
        name: "Junghundchampionat",
        issuedOn: "2025-08-23",
        organizations: ["CDK", "KCB"],
        qualifying: [
            { date: "2025-05-25", place: "Dernbach", note: "Montabaur Sieger (CDK e.V.)" },
            { date: "2025-06-15", place: "Quakenbrück", note: "Europasieger 2025 (DASV e.V.)" },
            { date: "2025-06-15", place: "Quakenbrück", note: "Internationaler Jubiläumssieger 2025 (ERHC e.V.)" },
        ],
    },
};


export const dogsSectionData = {
    huendinnen: [
        {
            id: "kira",
            name: "Kira (Amara of Beautiful little Diamond)",
            sex: "Hündin",
            imageSrc: "/assets/dogs/Claudia-4.jpg",
            subtitle: "Havaneser · weiß-zobel · 24,5 cm · 5,1 kg",
            description:
                "Kira ist unsere liebevolle Zuchthündin – ruhig, ausgeglichen und sehr sozial.",
            badges: [
                "Zuchttauglich seit 15.05.2025",
                "Patella 0/0 (frei)",
                "Augen: PRA + Katarakt (frei)",
                "Junghund Champion",
            ],
            details: [
                { label: "Wurftag", value: "14.08.2023" },
                { label: "Gebiss", value: "VZ 6/6, Schere" },
                { label: "Vater", value: "Athos von den nordischen Elfen" },
                { label: "Mutter", value: "Breathtaking Beauty Tequila" },
            ],
            highlights: [
                "SG2 Mons Tabor Winner – 2. Platz (26.05.2024)",
                "SG2 Westerwald Siegerschau – 2. Platz (26.05.2024)",
                "V1 Europasieger 2025 – 1. Platz (15.06.2025)",
                "V1 Internationaler Jubiläumssieger 2025 – 1. Platz (15.06.2025)",
            ],
            // Quelle: Kira-PDF
            // :contentReference[oaicite:3]{index=3}
        },

        {
            id: "sherry",
            name: "Sherry (Mariann' s Golden Roses Sherry)",
            sex: "Hündin",
            imageSrc: "/assets/dogs/ClaudiaDez2025-5.jpg",
            subtitle: "Havaneser · red · Langhaar (FCI Ungarn)",
            description:
                "Sherry wächst bei uns im Familienverbund auf und wird behutsam aufgebaut. Gesundheits- und Zuchtdaten werden nachgereicht.",
            badges: ["Junghündin", "noch nicht zuchttauglich"],
            details: [
                { label: "Wurftag", value: "19.08.2025" },
                { label: "Vater", value: "Jo The Funny One Barwuschel" },
                { label: "Mutter", value: "Dorothy Crimean Khan" },
                { label: "Züchter", value: "Marianna Incze (Ungarn)" },
            ],
            highlights: [],
        },

        {
            id: "amelie",
            name: "Amelie",
            sex: "Hündin",
            imageSrc: "/assets/dogs/Welpen-2.jpg",
            subtitle: "Havaneser · chocolate",
            description:
                "Amelie ist aus unserem aktuellen Wurf und wird bei uns bleiben. Weitere Daten folgen, sobald sie alt genug ist.",
            badges: ["Junghündin", "bleibt bei uns"],
            details: [],
            highlights: [],
        },
    ],

    rueden: [
        {
            id: "gino",
            name: "Gino",
            sex: "Rüde",
            // ⬇️ BITTE anpassen, sobald du das richtige Foto im Projekt hast:
            imageSrc: "/assets/dogs/Gino.jpeg",
            subtitle: "-",
            description:
                "Folgt",
            badges: ["Jungrüde", "Daten folgen"],
            details: [
                { label: "Wurftag", value: "Folgt" },
                { label: "Vater", value: "Folgt" },
                { label: "Mutter", value: "Folgt" },
                { label: "Züchter", value: "Folgt" },
            ],
            highlights: [],
        },
    ],
};

